import React from "react";

/**
 * NumberInput component
 *
 * Props:
 *  - label?: string
 *  - name: string
 *  - value: string | number
 *  - placeholder?: string
 *  - onChange: (e) => void
 *  - required?: boolean
 *  - min?: number
 *  - max?: number
 *  - step?: number
 *  - disabled?: boolean
 */
export function NumberInput({
  label,
  name,
  value,
  placeholder = "",
  onChange,
  required = false,
  min,
  max,
  step,
  disabled = false,
}) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input
        type="number"
        name={name}
        value={value}
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed transition-colors"
        onChange={onChange}
        required={required}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
      />
    </div>
  );
}